/* tslint:disable:ordered-imports */
import 'core-js/client/shim';
import '@Common/Core/Extension';
import { applicationType } from '@Common/Enums';

(function startup(): void {
    let appName = applicationType.getName(altosoft.appId);
    let pageName = strings.pageNames[altosoft.pageType];
    if (altosoft.pageType === 'mtConsole') {
        appName = pageName;
        pageName = undefined;
    }
    const fullPageName = strings.pageNames.pageNameFormat.format(appName, pageName || '');
    strings.applicationName = fullPageName;
    document.title = fullPageName;
})();
